import { useLookupOptions } from "../../hooks/useLookupOptions";
import {
  LookupRecord,
  getLookupOptionFilter,
} from "../../config/lookupOptionFilters";
import { LookupField } from "./LookupField";
import { LookupManageActions } from "./LookupManageActions";
import { EntityLookupFieldProps } from "./EntityLookupField.types";

const NoRecord: Record<string, unknown> = {};

/** A lookup whose candidates are another entity's records, read when the field shows. */
export function EntityLookupField({
  lookupEntity,
  optionFilterKey,
  searchFilter,
  record = NoRecord,
  placeholder,
  manageRoute,
  ...props
}: EntityLookupFieldProps) {
  const { options, loading, refresh } = useLookupOptions(
    lookupEntity,
    searchFilter
  );
  const filter = getLookupOptionFilter(optionFilterKey);
  const candidates = filter
    ? filter(options as LookupRecord[], record)
    : options;

  return (
    <LookupField
      {...props}
      placeholder={loading ? "Loading..." : placeholder}
      options={candidates.map((option) => ({
        id: String(option.Key),
        displayName: option.Value,
      }))}
      actions={
        manageRoute && !props.disabled ? (
          <LookupManageActions
            label={props.label}
            manageRoute={manageRoute}
            value={props.value}
            loading={loading}
            onRefresh={refresh}
          />
        ) : undefined
      }
    />
  );
}
